import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App/App.tsx';
import packageJson from '../package.json';

// Log app version to console with nice colors
console.log(
  '%cApp version: %c' + packageJson.version,
  'color: #4CAF50; font-weight: bold; font-size: 14px;',
  'color: #2196F3; font-weight: bold; font-size: 14px;'
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
